export const SUPPORT_CHAT_INLINE_ID = 'support-chat-inline';
export const SUPPORT_CHAT_INLINE_SELECTOR = `#${SUPPORT_CHAT_INLINE_ID}`;
